import { render, staticRenderFns } from "./ScrollTopButton.vue?vue&type=template&id=1971a38f&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollTopButton.vue?vue&type=style&index=0&id=1971a38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971a38f",
  null
  
)

export default component.exports